import * as React from "react";
import { CardContent, Step, StepLabel, Stepper } from "@mui/material";
import Box from "@mui/material/Box";
import { LoadingButton } from "@mui/lab";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SendIcon from "@mui/icons-material/Send";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { sxButtonsStack } from "./BoxAi-sx";
import { sxResultMainBox } from "./BoxAi-sx";
import {
  sxMainBox,
  sxStackContainer,
  sxStackHeader,
  sxAnalysisText,
  sxTextFeedback,
} from "./BoxAi-sx";

const steps = ["Carregar copmpetências", "Carregar feedbacks", "Enviar"];

const HeaderTitlesView = (
  <Stack spacing={2} useFlexGap sx={sxStackHeader}>
    <Typography variant="h1" sx={sxAnalysisText}>
      Análise de&nbsp;
      <Typography component="span" variant="h1" sx={sxTextFeedback}>
        Feedbacks
      </Typography>
    </Typography>
    <Typography variant="caption" textAlign="center" sx={{ opacity: 0.8 }}>
      Ao clicar em&quot;Enviar&quot; você concorda com nossos&nbsp;
      <Link href="#" color="primary">
        Termos e Condições
      </Link>
      .
    </Typography>
  </Stack>
);
export default function BoxAi({
  callAi: callAi,
  uploadSkills: uploadSkills,
  uploadFeedbacks: uploadFeedbacks,
  uploadedSkills: uploadedSkills,
  uploadedFeedback: uploadedFeedback,
  resultData: resultData,
  bottomView: bottomView,
  loading: loading,
}: {
  callAi: () => {};
  uploadSkills: () => void;
  uploadFeedbacks: () => void;
  uploadedSkills: string;
  uploadedFeedback: string;
  resultData: string;
  bottomView: JSX.Element;
  loading: boolean;
}) {
  const [activeStep, setActiveStep] = React.useState<number>(0);

  React.useEffect(() => {
    if (uploadedSkills === "" && uploadedFeedback === "") {
      setActiveStep(0);
    } else if (uploadedSkills !== "" && uploadedFeedback === "") {
      setActiveStep(1);
    } else if (uploadedSkills !== "" && uploadedFeedback !== "") {
      setActiveStep(2);
    }
  }, [uploadedSkills, uploadedFeedback]);

  function handleSendButton(
    callAi: () => {},
    uploadedSkills: string,
    uploadedFeedback: string,
    setActiveStep: React.Dispatch<React.SetStateAction<number>>
  ): React.MouseEventHandler<HTMLButtonElement> | undefined {
    return () => {
      callAi();
      if (uploadedSkills !== "" && uploadedFeedback !== "") {
        setActiveStep(3);
      }
    };
  }

  const horizontalStepper = (
    <Box sx={{ width: "100%", mt: 10 }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );

  const ButtonsView = (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
      spacing={2}
      useFlexGap
      sx={sxButtonsStack}
    >
      <LoadingButton
        onClick={uploadSkills}
        endIcon={<FileUploadOutlinedIcon />}
        loading={loading}
        loadingPosition="end"
        variant="contained"
        color={uploadedSkills !== "" ? "success" : "info"}
      >
        <span>Carregar competencias(CSV)</span>
      </LoadingButton>
      <LoadingButton
        onClick={handleSendButton(
          callAi,
          uploadedSkills,
          uploadedFeedback,
          setActiveStep
        )}
        endIcon={<SendIcon />}
        loading={loading}
        loadingPosition="end"
        variant="outlined"
      >
        <span>Enviar</span>
      </LoadingButton>
      <LoadingButton
        onClick={uploadFeedbacks}
        endIcon={<FileUploadOutlinedIcon />}
        loading={loading}
        loadingPosition="end"
        variant="contained"
        color={uploadedFeedback !== "" ? "success" : "info"}
      >
        <span>Carregar feedback(CSV)</span>
      </LoadingButton>
    </Stack>
  );

  return (
    <Box id="boxai" sx={sxMainBox}>
      <Container sx={sxStackContainer}>
        {HeaderTitlesView}
        <Box id="resultMainBox" sx={sxResultMainBox}>
          <CardContent>
            <Box alignItems={"revert"}>{bottomView}</Box>
            {ButtonsView}
            {horizontalStepper}
          </CardContent>
        </Box>
      </Container>
    </Box>
  );
}
